import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';

// ─── 아이콘 SVG ───

const ChatIcon = () => (
    <svg viewBox="0 0 100 100" className="hero-svg-icon">
        <defs>
            <linearGradient id="chatGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#01BCD6"/>
                <stop offset="100%" stopColor="#006674"/>
            </linearGradient>
        </defs>
        <rect x="10" y="15" width="80" height="55" rx="10" fill="url(#chatGradient)"/>
        <polygon points="25,70 35,70 20,85" fill="url(#chatGradient)"/>
        <circle cx="35" cy="42" r="5" fill="#fff"/>
        <circle cx="50" cy="42" r="5" fill="#fff"/>
        <circle cx="65" cy="42" r="5" fill="#fff"/>
    </svg>
);

const MeetingIcon = () => (
    <svg viewBox="0 0 100 100" className="hero-svg-icon">
        <defs>
            <linearGradient id="meetGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#01BCD6"/>
                <stop offset="100%" stopColor="#006674"/>
            </linearGradient>
        </defs>
        {/* 모니터 */}
        <rect x="15" y="12" width="70" height="50" rx="6" fill="url(#meetGradient)"/>
        {/* 화면 내부 */}
        <rect x="22" y="18" width="56" height="38" rx="3" fill="rgba(0,15,35,0.5)"/>
        {/* 화면 속 참가자 격자 */}
        <rect x="25" y="21" width="24" height="15" rx="2" fill="rgba(1,188,214,0.3)"/>
        <rect x="51" y="21" width="24" height="15" rx="2" fill="rgba(1,188,214,0.3)"/>
        <rect x="25" y="38" width="24" height="15" rx="2" fill="rgba(1,188,214,0.3)"/>
        <rect x="51" y="38" width="24" height="15" rx="2" fill="rgba(1,188,214,0.3)"/>
        {/* 사람 아이콘들 */}
        <circle cx="37" cy="27" r="3" fill="#fff" opacity="0.8"/>
        <circle cx="63" cy="27" r="3" fill="#fff" opacity="0.8"/>
        <circle cx="37" cy="44" r="3" fill="#fff" opacity="0.8"/>
        <circle cx="63" cy="44" r="3" fill="#fff" opacity="0.8"/>
        {/* 스탠드 */}
        <rect x="42" y="62" width="16" height="4" rx="1" fill="url(#meetGradient)"/>
        <rect x="35" y="66" width="30" height="3" rx="1.5" fill="url(#meetGradient)"/>
        {/* 마우스 커서 */}
        <polygon points="65,48 65,60 70,56 75,62 77,60 72,54 76,52" fill="#fff" opacity="0.9"/>
    </svg>
);

const NodeMasterIcon = () => (
    <svg viewBox="0 0 100 100" className="hero-svg-icon">
        <defs>
            <linearGradient id="nodeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#01BCD6"/>
                <stop offset="100%" stopColor="#006674"/>
            </linearGradient>
        </defs>
        {/* 중앙 허브 */}
        <circle cx="50" cy="50" r="12" fill="url(#nodeGradient)"/>
        {/* 연결선 */}
        <line x1="50" y1="38" x2="50" y2="18" stroke="rgba(1,188,214,0.5)" strokeWidth="2.5"/>
        <line x1="50" y1="62" x2="50" y2="82" stroke="rgba(1,188,214,0.5)" strokeWidth="2.5"/>
        <line x1="38" y1="50" x2="18" y2="50" stroke="rgba(1,188,214,0.5)" strokeWidth="2.5"/>
        <line x1="62" y1="50" x2="82" y2="50" stroke="rgba(1,188,214,0.5)" strokeWidth="2.5"/>
        <line x1="41" y1="41" x2="26" y2="26" stroke="rgba(1,188,214,0.35)" strokeWidth="2"/>
        <line x1="59" y1="41" x2="74" y2="26" stroke="rgba(1,188,214,0.35)" strokeWidth="2"/>
        <line x1="41" y1="59" x2="26" y2="74" stroke="rgba(1,188,214,0.35)" strokeWidth="2"/>
        <line x1="59" y1="59" x2="74" y2="74" stroke="rgba(1,188,214,0.35)" strokeWidth="2"/>
        {/* 외부 노드들 */}
        <circle cx="50" cy="13" r="7" fill="url(#nodeGradient)" opacity="0.85"/>
        <circle cx="50" cy="87" r="7" fill="url(#nodeGradient)" opacity="0.85"/>
        <circle cx="13" cy="50" r="7" fill="url(#nodeGradient)" opacity="0.85"/>
        <circle cx="87" cy="50" r="7" fill="url(#nodeGradient)" opacity="0.85"/>
        <circle cx="22" cy="22" r="5.5" fill="rgba(1,188,214,0.6)"/>
        <circle cx="78" cy="22" r="5.5" fill="rgba(1,188,214,0.6)"/>
        <circle cx="22" cy="78" r="5.5" fill="rgba(1,188,214,0.6)"/>
        <circle cx="78" cy="78" r="5.5" fill="rgba(1,188,214,0.6)"/>
        {/* 중앙 코어 */}
        <circle cx="50" cy="50" r="5" fill="#fff" opacity="0.9"/>
    </svg>
);

const GanttIcon = () => (
    <svg viewBox="0 0 100 100" className="hero-svg-icon">
        <defs>
            <linearGradient id="ganttGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#01BCD6"/>
                <stop offset="100%" stopColor="#006674"/>
            </linearGradient>
            <linearGradient id="ganttBar2" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#01BCD6" stopOpacity="0.7"/>
                <stop offset="100%" stopColor="#006674" stopOpacity="0.7"/>
            </linearGradient>
        </defs>
        {/* 배경 패널 */}
        <rect x="8" y="8" width="84" height="84" rx="10" fill="rgba(1,188,214,0.06)" stroke="rgba(1,188,214,0.2)" strokeWidth="1.5"/>
        {/* 헤더 */}
        <rect x="8" y="8" width="84" height="18" rx="10" fill="url(#ganttGradient)" opacity="0.6"/>
        <rect x="8" y="18" width="84" height="8" fill="url(#ganttGradient)" opacity="0.6"/>
        {/* 눈금선 */}
        {[38,52,66,80].map((y,i) => (
            <line key={i} x1="8" y1={y} x2="92" y2={y} stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
        ))}
        {/* 간트 바 */}
        <rect x="28" y="30" width="45" height="9" rx="4" fill="url(#ganttGradient)"/>
        <rect x="38" y="43" width="35" height="9" rx="4" fill="url(#ganttBar2)"/>
        <rect x="22" y="56" width="50" height="9" rx="4" fill="url(#ganttGradient)" opacity="0.8"/>
        <rect x="42" y="69" width="28" height="9" rx="4" fill="url(#ganttBar2)"/>
        {/* 좌측 레이블 점 */}
        <circle cx="20" cy="34.5" r="3" fill="#fff" opacity="0.5"/>
        <circle cx="20" cy="47.5" r="3" fill="#fff" opacity="0.5"/>
        <circle cx="20" cy="60.5" r="3" fill="#fff" opacity="0.5"/>
        <circle cx="20" cy="73.5" r="3" fill="#fff" opacity="0.5"/>
    </svg>
);

const PlatformIcons = {
    windows: () => (
        <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/>
        </svg>
    ),
    mac: () => (
        <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
    ),
    linux: () => (
        <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.268-.45.6-.663.839-.199.199-.485.267-.797.4-.313.136-.658.269-.864.68-.09.189-.136.394-.132.602 0 .199.027.4.055.536.058.399.116.728.04.97-.249.68-.28 1.145-.106 1.484.174.334.535.47.94.601.81.2 1.91.135 2.774.6.926.466 1.866.67 2.616.47.526-.116.97-.464 1.208-.946.587-.003 1.23-.269 2.26-.334.699-.058 1.574.267 2.577.2.025.134.063.198.114.333l.003.003c.391.778 1.113 1.368 1.884 1.564.777.2 1.604.023 2.205-.468.002.001.004 0 .005 0 .137-.067.27-.148.392-.265.246-.24.371-.58.395-.94.016-.267-.012-.465-.016-.665-.048-.435-.063-.47.193-.836.126-.199.09-.478.014-.667-.076-.199-.145-.362-.174-.536a3.04 3.04 0 01.002-.773c.076-.334.206-.668.1-.999-.135-.434-.37-.515-.697-.543-.313-.025-.64-.068-.876-.397-.098-.166-.16-.332-.206-.497l-.003-.003c-.023-.199-.032-.398-.112-.597-.2-.6-.67-1.065-1.134-1.332-.47-.268-.95-.466-1.297-.8-.685-.659-.621-1.597-.492-2.536.116-.867.088-1.736-.029-2.536-.064-.465-.105-.868-.057-1.202.04-.267.135-.51.293-.706.074-.09.148-.174.227-.254a8.128 8.128 0 00.546-.629c.403-.602.59-1.205.455-1.937-.203-1.034-.604-2.304-1.57-3.275C14.566.438 13.562 0 12.504 0z"/>
        </svg>
    ),
    ios: () => (
        <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
    ),
    android: () => (
        <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.523 15.3414c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zm-11.046 0c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zM17.09 7.937l1.638-2.838a.34.34 0 00-.588-.34l-1.66 2.874a10.41 10.41 0 00-4.48-1.002 10.41 10.41 0 00-4.48 1.002L5.86 4.76a.34.34 0 10-.588.34L6.91 7.937C3.845 9.587 1.737 12.556 1.5 16h21c-.237-3.444-2.345-6.413-5.41-8.063z"/>
        </svg>
    ),
};

const PLATFORM_LABELS = {
    windows: 'Windows 10/11',
    mac: 'macOS 12+',
    linux: 'Ubuntu / Debian',
    ios: 'iOS 15+',
    android: 'Android 10+',
};

const PLATFORM_NAMES = {
    windows: 'Windows',
    mac: 'macOS',
    linux: 'Linux',
    ios: 'iPhone',
    android: 'Android',
};

// ─── 기능 아이콘 ───

const FeatureIcon = ({ type }) => {
    const icons = {
        chat: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
        ),
        group: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
        ),
        file: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
            </svg>
        ),
        security: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
        ),
        screen: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
            </svg>
        ),
        remote: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <polyline points="15 3 21 3 21 9"/>
                <polyline points="9 21 3 21 3 15"/>
                <line x1="21" y1="3" x2="14" y2="10"/>
                <line x1="3" y1="21" x2="10" y2="14"/>
            </svg>
        ),
        video: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <polygon points="23 7 16 12 23 17 23 7"/>
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
            </svg>
        ),
        mic: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                <line x1="12" y1="19" x2="12" y2="23"/>
                <line x1="8" y1="23" x2="16" y2="23"/>
            </svg>
        ),
    };
    return icons[type] || null;
};

// ─── 제품 설정 ───

const PRODUCTS = {
    antstalk: {
        name: 'AntsTalk',
        subtitle: '실시간 소통의 새로운 기준',
        desc: '빠르고 안전한 메시징으로 팀과 함께 일하세요.\n앤츠네스트의 공식 메신저입니다.',
        icon: ChatIcon,
        platforms: ['windows', 'mac', 'linux', 'ios', 'android'],
        storeLinks: [{ label: 'Microsoft Store', url: 'https://apps.microsoft.com/detail/9P4223H2QSNS?hl=ko-kr&gl=KR&ocid=pdpshare' }],
        features: [
            { type: 'chat', title: '실시간 채팅', desc: '1:1 및 그룹 채팅으로 빠른 소통' },
            { type: 'group', title: '팀 협업', desc: '프로젝트별 채널로 체계적 관리' },
            { type: 'file', title: '파일 공유', desc: '문서, 이미지, 동영상 간편 전송' },
            { type: 'security', title: '보안', desc: '종단간 암호화로 안전한 대화' },
        ],
    },
    antsmeeting: {
        name: 'AntsMeeting',
        subtitle: '원격 데스크톱 & 화상회의',
        desc: '화면 공유, 원격 제어, 음성 통화를 하나로.\n앤츠네스트의 원격 협업 솔루션입니다.',
        icon: MeetingIcon,
        platforms: ['windows'],
        storeLinks: [{ label: 'Microsoft Store', url: 'https://apps.microsoft.com/detail/9N6Z6WN1ZGGW?hl=ko-kr&gl=KR&ocid=pdpshare' }],
        features: [
            { type: 'screen', title: '화면 공유', desc: '고화질 실시간 화면 공유' },
            { type: 'remote', title: '원격 제어', desc: '상대 PC를 직접 조작' },
            { type: 'video', title: '화상 회의', desc: '다자간 음성·영상 회의' },
            { type: 'mic', title: '음성 통화', desc: '고품질 음성으로 실시간 소통' },
        ],
    },
    nodemaster: {
        name: 'NodeMaster',
        subtitle: '서버 & 네트워크 통합 관리',
        desc: '서버 상태, 네트워크 토폴로지, 장애 알림을\n하나의 대시보드에서 관리하세요.',
        icon: NodeMasterIcon,
        platforms: ['windows'],
        storeLinks: [
            { label: '로컬 버전', url: 'https://apps.microsoft.com/detail/9NRCCW6WP8W0?hl=ko-kr&gl=KR&ocid=pdpshare' },
            { label: 'Teams 앱',  url: 'https://apps.microsoft.com/detail/9NZM34KKN3F1?hl=ko-kr&gl=KR&ocid=pdpshare' },
        ],
        // 업로드 구분만 다르고 카드는 하나 — 다운로드 버튼만 2개로 분기
        variants: [
            { key: 'nodemaster_local', label: '로컬' },
            { key: 'nodemaster_teams', label: 'Teams' },
        ],
        features: [
            { type: 'screen', title: '실시간 모니터링', desc: '서버·노드 상태를 한눈에 파악' },
            { type: 'security', title: '장애 감지', desc: '이상 징후 자동 감지 및 알림' },
            { type: 'remote', title: '원격 관리', desc: '원격으로 노드 설정·제어' },
            { type: 'group', title: '토폴로지 뷰', desc: '네트워크 구조 시각화' },
        ],
    },
    ganttchart: {
        name: 'GanttChart',
        subtitle: '스마트 프로젝트 일정 관리',
        desc: '간트 차트로 프로젝트 일정을 시각화하고\n팀 협업을 효율적으로 관리하세요.',
        icon: GanttIcon,
        platforms: ['windows'],
        storeLinks: [{ label: 'Microsoft Store', url: 'https://apps.microsoft.com/detail/9PK7XWKSRCLF?hl=ko-kr&gl=KR&ocid=pdpshare' }],
        features: [
            { type: 'file', title: '일정 시각화', desc: '드래그로 간편한 일정 편집' },
            { type: 'group', title: '팀 협업', desc: '담당자 지정 및 진행률 관리' },
            { type: 'chat', title: '실시간 동기화', desc: '팀원과 변경사항 즉시 공유' },
            { type: 'security', title: '마감 알림', desc: '기한 초과 전 자동 알림' },
        ],
    },
};

// ─── 메인 컴포넌트 ───

export default function Download() {
    const [activeProduct, setActiveProduct] = useState('antstalk');
    const [releases, setReleases] = useState({});
    const [downloading, setDownloading] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [archiveFiles, setArchiveFiles] = useState([]);
    const [archiveLoading, setArchiveLoading] = useState(false);
    const [uploadForm, setUploadForm] = useState({ title: '', description: '', category: '일반', file: null });
    const [uploading, setUploading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // 전 제품 릴리스 로드
        ['antstalk', 'antsmeeting', 'nodemaster_local', 'nodemaster_teams', 'ganttchart'].forEach(product => {
            fetch(`/api/releases?product=${product}`)
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setReleases(prev => ({ ...prev, [product]: data.releases }));
                    }
                })
                .catch(() => {});
        });

        fetch('/api/check-session', { credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                if (data.success && data.user) {
                    const account = data.user.user_account || data.user.userId;
                    setIsLoggedIn(true);
                    if (account === 'admin@antsnest.co.kr') setIsAdmin(true);
                    loadArchiveFiles();
                }
            })
            .catch(() => {});
    }, []);

    const loadArchiveFiles = () => {
        setArchiveLoading(true);
        fetch('/api/archive/files', { credentials: 'include' })
            .then(res => res.json())
            .then(data => { if (data.success) setArchiveFiles(data.files); })
            .catch(() => {})
            .finally(() => setArchiveLoading(false));
    };

    const handleArchiveUpload = async (e) => {
        e.preventDefault();
        if (!uploadForm.file || !uploadForm.title) return;
        setUploading(true);
        const fd = new FormData();
        fd.append('file', uploadForm.file);
        fd.append('title', uploadForm.title);
        fd.append('description', uploadForm.description);
        fd.append('category', uploadForm.category);
        try {
            const res = await fetch('/api/admin/archive', { method: 'POST', credentials: 'include', body: fd });
            const data = await res.json();
            if (data.success) {
                setUploadForm({ title: '', description: '', category: '일반', file: null, _open: false });
                loadArchiveFiles();
            }
        } catch(e) {}
        setUploading(false);
    };

    const handleArchiveDelete = async (id) => {
        if (!window.confirm('삭제하시겠습니까?')) return;
        try {
            await fetch(`/api/admin/archive/${id}`, { method: 'DELETE', credentials: 'include' });
            loadArchiveFiles();
        } catch(e) {}
    };

    const formatSize = (bytes) => {
        if (!bytes) return '';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    };

    const getRelease = (platform) => {
        const productReleases = releases[activeProduct] || [];
        return productReleases.find(r => r.platform === platform);
    };

    const handleDownload = (url) => {
        if (!url || url === '#') return;
        setDownloading(true);
        window.location.href = url;
        setTimeout(() => setDownloading(false), 2000);
    };

    const product = PRODUCTS[activeProduct];
    const HeroIcon = product ? product.icon : null;
    const winRelease = product ? getRelease('windows') : null;

    return (
        <div className='DownloadContents'>
            <div className='HomeContainer'>

                {/* ── 제품 탭 ── */}
                <div className="ProductTabs">
                    {Object.entries(PRODUCTS).map(([key, p]) => (
                        <button
                            key={key}
                            className={`ProductTab ${activeProduct === key ? 'active' : ''}`}
                            onClick={() => setActiveProduct(key)}
                        >
                            {p.name}
                        </button>
                    ))}
                    <button
                        className={`ProductTab ${activeProduct === 'archive' ? 'active' : ''}`}
                        onClick={() => setActiveProduct('archive')}
                    >
                        자료실
                    </button>
                </div>

                {activeProduct === 'archive' ? (
                    /* ── 자료실 탭 ── */
                    <div className="ArchiveSection">
                        {!isLoggedIn ? (
                            <div className="ArchiveLoginPrompt">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="1.5" width="48" height="48">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                                <p className="ArchiveLoginTitle">로그인이 필요한 서비스입니다</p>
                                <p className="ArchiveLoginDesc">자료실은 앤츠네스트 회원만 이용할 수 있습니다.</p>
                                <button className="ArchiveLoginBtn" onClick={() => navigate('/Login')}>로그인하기</button>
                            </div>
                        ) : (
                            <>
                                {/* 게시판 헤더 */}
                                <div className="ArchiveBoardHeader">
                                    <div className="ArchiveBoardInfo">
                                        <span className="ArchiveBoardCount">총 <strong>{archiveFiles.length}</strong>개의 자료</span>
                                    </div>
                                    {isAdmin && (
                                        <button className="ArchiveWriteBtn" onClick={() => setUploadForm(p => ({...p, _open: !p._open}))}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                                            </svg>
                                            업로드
                                        </button>
                                    )}
                                </div>

                                {/* 업로드 폼 (어드민, 토글) */}
                                {isAdmin && uploadForm._open && (
                                    <form className="ArchiveUploadForm" onSubmit={handleArchiveUpload}>
                                        <div className="ArchiveUploadFormTitle">새 자료 업로드</div>
                                        <div className="ArchiveUploadGrid">
                                            <input
                                                type="text" placeholder="제목 *" required
                                                value={uploadForm.title}
                                                onChange={e => setUploadForm(p => ({...p, title: e.target.value}))}
                                                className="ArchiveInput"
                                            />
                                            <select
                                                value={uploadForm.category}
                                                onChange={e => setUploadForm(p => ({...p, category: e.target.value}))}
                                                className="ArchiveInput"
                                            >
                                                {['일반','매뉴얼','정책','양식','기타'].map(c => <option key={c}>{c}</option>)}
                                            </select>
                                        </div>
                                        <input
                                            type="text" placeholder="설명 (선택)"
                                            value={uploadForm.description}
                                            onChange={e => setUploadForm(p => ({...p, description: e.target.value}))}
                                            className="ArchiveInput"
                                        />
                                        <div className="ArchiveUploadFileRow">
                                            <label className="ArchiveFileLabel">
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                    <polyline points="17 8 12 3 7 8"/>
                                                    <line x1="12" y1="3" x2="12" y2="15"/>
                                                </svg>
                                                {uploadForm.file ? uploadForm.file.name : '파일 선택'}
                                                <input type="file" required style={{display:'none'}}
                                                    onChange={e => setUploadForm(p => ({...p, file: e.target.files[0]}))}
                                                />
                                            </label>
                                            <div className="ArchiveUploadActions">
                                                <button type="button" className="ArchiveCancelBtn"
                                                    onClick={() => setUploadForm({ title: '', description: '', category: '일반', file: null, _open: false })}>
                                                    취소
                                                </button>
                                                <button type="submit" className="ArchiveUploadBtn" disabled={uploading}>
                                                    {uploading ? '업로드 중...' : '업로드'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )}

                                {/* 게시판 테이블 */}
                                {archiveLoading ? (
                                    <div className="ArchiveEmpty">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" width="40" height="40">
                                            <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
                                        </svg>
                                        <p>불러오는 중...</p>
                                    </div>
                                ) : archiveFiles.length === 0 ? (
                                    <div className="ArchiveEmpty">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" width="48" height="48">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                            <polyline points="14 2 14 8 20 8"/>
                                            <line x1="16" y1="13" x2="8" y2="13"/>
                                            <line x1="16" y1="17" x2="8" y2="17"/>
                                            <polyline points="10 9 9 9 8 9"/>
                                        </svg>
                                        <p>등록된 자료가 없습니다.</p>
                                    </div>
                                ) : (
                                    <div className="ArchiveBoard">
                                        <div className="ArchiveBoardHead">
                                            <span className="col-no">번호</span>
                                            <span className="col-cat">분류</span>
                                            <span className="col-title">제목</span>
                                            <span className="col-size">크기</span>
                                            <span className="col-date">등록일</span>
                                            <span className="col-action"></span>
                                        </div>
                                        {archiveFiles.map((f, idx) => (
                                            <div className="ArchiveBoardRow" key={f.id}>
                                                <span className="col-no">{archiveFiles.length - idx}</span>
                                                <span className="col-cat">
                                                    <span className="ArchiveCatBadge">{f.category}</span>
                                                </span>
                                                <div className="col-title">
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="1.8" width="16" height="16" style={{flexShrink:0}}>
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                                        <polyline points="14 2 14 8 20 8"/>
                                                    </svg>
                                                    <div>
                                                        <span className="ArchiveTitleText">{f.title}</span>
                                                        {f.description && <span className="ArchiveDescText">{f.description}</span>}
                                                    </div>
                                                </div>
                                                <span className="col-size">{formatSize(f.file_size)}</span>
                                                <span className="col-date">{new Date(f.created_at).toLocaleDateString('ko-KR')}</span>
                                                <div className="col-action">
                                                    <a href={`/api/archive/download/${f.id}`} className="ArchiveDownBtn">
                                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="13" height="13">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                            <polyline points="7 10 12 15 17 10"/>
                                                            <line x1="12" y1="15" x2="12" y2="3"/>
                                                        </svg>
                                                        다운로드
                                                    </a>
                                                    {isAdmin && (
                                                        <button className="ArchiveDelBtn" onClick={() => handleArchiveDelete(f.id)}>삭제</button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ) : (
                    <>
                        {/* ── 히어로 섹션 ── */}
                        <div className="DownloadHero">
                            <div className="HeroContent">
                                <div className="HeroText">
                                    <h1>{product.name}</h1>
                                    <p className="HeroSubtitle">{product.subtitle}</p>
                                    <p className="HeroDesc">
                                        {product.desc.split('\n').map((line, i) => (
                                            <React.Fragment key={i}>{line}<br/></React.Fragment>
                                        ))}
                                    </p>
                                    <div className={`HeroBtnGroup${product.variants ? ' HeroBtnGroup--grid2' : ''}`}>
                                        {/* 메인: Microsoft Store 버튼들 */}
                                        {(product.storeLinks || []).map((s, i) => (
                                            <a
                                                key={i}
                                                className="StoreBadgeBtn"
                                                href={s.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                                                    <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/>
                                                </svg>
                                                {(product.storeLinks || []).length > 1
                                                    ? `Store — ${s.label}`
                                                    : 'Microsoft Store에서 받기'}
                                            </a>
                                        ))}
                                        {/* 서브: 직접 다운로드 — variants 있으면 분기 */}
                                        {product.variants ? (
                                            product.variants.map(v => {
                                                const vReleases = releases[v.key] || [];
                                                const vRelease = vReleases.find(r => r.platform === 'windows');
                                                if (!vRelease) return null;
                                                return (
                                                    <button
                                                        key={v.key}
                                                        className={`DownloadBtnSub ${downloading ? 'downloading' : ''}`}
                                                        onClick={() => handleDownload(vRelease.download_url)}
                                                        disabled={downloading}
                                                    >
                                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                            <polyline points="7 10 12 15 17 10"/>
                                                            <line x1="12" y1="15" x2="12" y2="3"/>
                                                        </svg>
                                                        {downloading ? '다운로드 중...' : `${v.label} 다운로드`}
                                                        <span className="VersionTagInline">v{vRelease.version}</span>
                                                    </button>
                                                );
                                            })
                                        ) : winRelease ? (
                                            <button
                                                className={`DownloadBtnSub ${downloading ? 'downloading' : ''}`}
                                                onClick={() => handleDownload(winRelease.download_url)}
                                                disabled={downloading}
                                            >
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                    <polyline points="7 10 12 15 17 10"/>
                                                    <line x1="12" y1="15" x2="12" y2="3"/>
                                                </svg>
                                                {downloading ? '다운로드 중...' : '직접 다운로드'}
                                                {winRelease && <span className="VersionTagInline">v{winRelease.version}</span>}
                                            </button>
                                        ) : null}
                                    </div>
                                    {isAdmin && (
                                        <button className="AdminBtn" onClick={() => navigate('/Download/Admin')}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                                <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
                                                <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                                            </svg>
                                            릴리스 관리
                                        </button>
                                    )}
                                </div>
                                <div className="HeroIcon">
                                    <HeroIcon />
                                </div>
                            </div>
                        </div>

                        {/* ── 플랫폼별 다운로드 ── */}
                        <div className="PlatformSection">
                            <h2>플랫폼별 다운로드</h2>
                            <div className="PlatformGrid" style={{
                                gridTemplateColumns: `repeat(${Math.min(product.platforms.length, 4)}, 1fr)`
                            }}>
                                {product.platforms.map((pid) => {
                                    const release = getRelease(pid);
                                    const Icon = PlatformIcons[pid];
                                    const hasRelease = !!release;
                                    const isWin = pid === 'windows';
                                    return (
                                        <div className={`PlatformCard ${hasRelease || isWin ? '' : 'disabled'}`} key={pid}>
                                            <div className="PlatformIconBox">
                                                <Icon />
                                            </div>
                                            <h3>{PLATFORM_NAMES[pid]}</h3>
                                            <p className="PlatformLabel">{PLATFORM_LABELS[pid]}</p>
                                            {hasRelease && <span className="PlatformVersion">v{release.version}</span>}
                                            {isWin && (product.storeLinks || []).length > 0 ? (
                                                <div className="PlatformBtnGroup">
                                                    {(product.storeLinks || []).map((s, i) => (
                                                        <a
                                                            key={i}
                                                            className="PlatformStoreBtn"
                                                            href={s.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                                                                <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/>
                                                            </svg>
                                                            {(product.storeLinks || []).length > 1 ? s.label : 'Store'}
                                                        </a>
                                                    ))}
                                                    {hasRelease && (
                                                        <button
                                                            className="PlatformBtn"
                                                            onClick={() => handleDownload(release.download_url)}
                                                        >
                                                            직접 다운로드
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <button
                                                    className={`PlatformBtn ${!hasRelease ? 'disabled' : ''}`}
                                                    onClick={() => hasRelease && handleDownload(release.download_url)}
                                                    disabled={!hasRelease}
                                                >
                                                    {hasRelease ? '다운로드' : '준비 중'}
                                                </button>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* ── 기능 섹션 ── */}
                        <div className="DownloadFeatures">
                            <h2>주요 기능</h2>
                            <div className="FeatureGrid" style={{
                                gridTemplateColumns: `repeat(${Math.min(product.features.length, 4)}, 1fr)`
                            }}>
                                {product.features.map((f, i) => (
                                    <div className="FeatureCard" key={i}>
                                        <div className="FeatureIconBox"><FeatureIcon type={f.type} /></div>
                                        <h3>{f.title}</h3>
                                        <p>{f.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}

            </div>
        </div>
    );
}
